module.exports = __webpack_public_path__ + "static/media/birthday.e4165ee0.svg";